import { render, staticRenderFns } from "./PostWidget.vue?vue&type=template&id=0b944894&"
import script from "./PostWidget.vue?vue&type=script&lang=js&"
export * from "./PostWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports